<template>
  <div style="height: calc(100% - 40px);padding-top: 16px">
    <el-container class="fullheight" style="border: 1px solid #eee">
      <fe-aside-tree cat-id="7" @node-click="handleNodeClick" @check="check" />
      <el-container>
        <el-main>
          <eco-table
            @load="loadData"
            :data="data"
            :pageResult="pageResult"
            :selection="false"
            quick-search-props="name,formKey"
            :default-sorter="[{ direction: 'DESC', property: 'updateTime' }]"
            :show-export="false"
            ref="ecoTable"
          >
            <template>
              <eco-table-column type="index" width="50" align="center" label="序号" />
              <eco-table-column prop="name" label="名称" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
              <eco-table-column prop="formKey" label="别名" :sortable="true" :show-overflow-tooltip="true" />
              <eco-table-column
                prop="status"
                label="状态"
                width="80"
                :filters="[
                  { text: '草稿', value: 'draft' },
                  { text: '已发布', value: 'deploy' }
                ]"
              >
                <template v-slot="{ row }">
                  <el-tag type="info" v-if="row.status == 'deploy'">已发布</el-tag>
                  <el-tag type="danger" v-if="row.status == 'draft'">草稿</el-tag>
                </template>
              </eco-table-column>
              <eco-table-column prop="version" label="版本" width="50"> </eco-table-column>
              <eco-table-column prop="typeName" label="分类" :sortable="true" />
              <eco-table-column prop="desc" label="描述" :hidden="true" />
              <eco-table-column width="200" label="操作">
                <template v-slot="{ row }">
                  <el-dropdown size="mini" @command="handleCommand">
                    <el-link type="primary" :underline="false">操作说明维护<i class="el-icon-arrow-down el-icon--right"></i></el-link>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ row: row, command: 'operationInstructions' }">操作说明维护</el-dropdown-item>
                      <el-dropdown-item :command="{ row: row, command: 'formRight' }" v-if="row.status == 'deploy'">表单权限</el-dropdown-item>
                      <el-dropdown-item :command="{ row: row, command: 'formExpand' }" v-if="row.status == 'deploy'">表单扩展</el-dropdown-item>
                      <el-dropdown-item :command="{ row: row, command: 'waterMark' }" v-if="row.status == 'deploy'">设置水印</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </eco-table-column>
            </template>
          </eco-table>
        </el-main>
        <FormDesignRules ref="FormDesignRules"></FormDesignRules>
        <FormExpandManage ref="FormExpandManage"></FormExpandManage>
        <el-drawer
          class="sideDrawer"
          destroy-on-close
          :size="drawerSize"
          title="操作说明维护"
          :visible.sync="OperationInstructions"
          :close-on-click-modal="false"
          :before-close="handleClose"
        >
          <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
          <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
          <el-form label-width="80px" :model="InstructionsForm" style="padding: 20px">
            <el-form-item label="表单名称:" prop="formName">
              <el-input v-model="InstructionsForm.formName" disabled></el-input>
            </el-form-item>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabList" :key="item.name"></el-tab-pane>
            </el-tabs>
            <el-form-item label-width="0" prop="formDesc" v-if="['first'].includes(activeName)">
              <FeEditor v-model="InstructionsForm.formDesc" :config="myConfig"></FeEditor>
            </el-form-item>
            <el-form-item label-width="0" prop="descNote" v-if="['third'].includes(activeName)">
              <FeEditor v-model="InstructionsForm.descNote" :config="myConfig"></FeEditor>
            </el-form-item>
            <template v-if="['second'].includes(activeName)">
              <el-button type="primary" @click="addStep(0)" v-if="!InstructionsForm.formInfoDetailRequestVoList.length">新增步骤</el-button>
              <div class="operate_step" v-if="InstructionsForm.formInfoDetailRequestVoList && InstructionsForm.formInfoDetailRequestVoList.length">
                <div class="operate_step_item" v-for="(item, index) in InstructionsForm.formInfoDetailRequestVoList" :key="index">
                  <el-row :gutter="10" class="operate_step_content">
                    <el-col :span="16">
                      <div class="step_content">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-form-item label="排序:">
                              <el-input v-model.number="item.sn"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="步骤名称:">
                              <el-input v-model="item.infoName" maxlength="10"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="step_btn">
                        <el-button type="text" @click="addStep(InstructionsForm.formInfoDetailRequestVoList.length)">新增步骤</el-button>
                        <el-button type="text" @click="deleteStep(index)">删除步骤</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <el-form-item label="附件:">
                    <eip-attachment
                      v-model="item.attachment"
                      model-name="item.attachment"
                      :permission="'w'"
                      propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
                      accept="jpg,jpeg,png,bmp,JPG,JPEG,PBG,BMP"
                      limit="1"
                      displayType="table"
                      isInputEdit=""
                      :configAttributes="{}"
                      :multiple="true"
                    >
                      <span slot="labeldesc">附件</span>
                    </eip-attachment>
                  </el-form-item>
                  <el-form-item label="步骤说明:">
                    <FeEditor v-model="item.formDesc" :config="myConfigNoImg"></FeEditor>
                  </el-form-item>
                </div>
              </div>
            </template>

            <el-form-item label="附件：" prop="attachment" v-if="['fourth'].includes(activeName)">
              <eip-attachment
                v-if="OperationInstructions"
                v-model="InstructionsForm.attachment"
                model-name="InstructionsForm.attachment"
                :permission="'w'"
                propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
                accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
                limit="10"
                displayType="table"
                isInputEdit=""
                :configAttributes="{}"
                :multiple="true"
              >
                <span slot="labeldesc">附件</span>
              </eip-attachment>
            </el-form-item>
          </el-form>

          <div class="demo-drawer__footer">
            <el-button @click="initOperationInstructions" type="default">取 消</el-button>
            <el-button type="primary" @click="PreviewDialog">预 览</el-button>
            <el-button @click="saveOperationInstructions" type="default">保 存</el-button>
            <el-button @click="defaultOperationInstructions(InstructionsForm, true)" type="default">恢复默认内容</el-button>
          </div>
        </el-drawer>
        <el-dialog v-if="OperationPreview" title="操作说明" :visible.sync="OperationPreview" width="70%" :before-close="handlePreviewClose">
          <div style="height: 600px">
            <iframe frameborder="0" name="frmFrame" scrolling="no" width="100%" height="100%" :src="saveHtml"></iframe>
          </div>
        </el-dialog>
        <el-dialog title="设置水印" :visible.sync="waterMarkVisible" width="50%" :before-close="handleWaterMarkClose">
          <el-form label-width="120px" :model="waterMarkSetting" data-vv-scope="waterMarkForm">
            <el-form-item label="关联水印:" prop="id">
              <eco-select
                v-model="waterMarkSetting.id"
                :options="waterMarkSettingOptions"
                :props="{ key: 'id', value: 'watermark_name' }"
                :validate="{ required: true }"
              >
              </eco-select>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="saveWaterMark" type="primary" scope-name="waterMarkForm">保 存</el-button>
            <el-button @click="handleWaterMarkClose" type="default">取 消</el-button>
          </span>
        </el-dialog>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Base64 } from 'js-base64'
import form from '@/api/form.js'
import req from '@/request.js'
const FeAsideTree = () => import('@/components/common/FeAsideTree.vue')
import utils from '@/eco-ui-util.js'
import FormDesignRules from './formDesignRules.vue'
import FormExpandManage from './FormExpandManage.vue'
import portal from '@/api/portal'
const formDesignRules = () => import('./formDesignRules.vue')
const FeEditor = () => import('@/components/common/FeEditor.vue')
export default {
  components: {
    FeAsideTree,
    formDesignRules,
    FormDesignRules,
    FeEditor,
    FormExpandManage
  },
  data() {
    return {
      drawerSize: '70%',
      myConfig: {
        initialFrameHeight: 240,
        UEDITOR_HOME_URL: '/ueditor/',
        // UEDITOR_HOME_URL: window.location.origin +'/'+ window.location.pathname.split('/')[1]+'/ueditor/',
        toolbars: [
          [
            'source',
            'undo', //撤销
            'bold', //加粗
            'indent', //首行缩进
            'italic', //斜体
            'underline', //下划线
            'strikethrough', //删除线
            'subscript', //下标
            'fontborder', //字符边框
            'superscript', //上标
            'formatmatch', //格式刷
            'fontfamily', //字体
            'fontsize', //字号
            'justifyleft', //居左对齐
            'justifycenter', //居中对齐
            'justifyright', //居右对齐
            'justifyjustify', //两端对齐
            'insertorderedlist', //有序列表
            'insertunorderedlist', //无序列表
            'lineheight', //行间距
            'forecolor', //字体颜色
            'simpleUpload'
          ]
        ],
        // 上传文件接口
        imageMaxSize: 2048000,
        imageAllowFiles: ['.png', '.jpg', '.jpeg'],
        imageFieldName: 'file',
        // 初始容器宽度
        initialFrameWidth: '100%',
        zIndex: 9001,
        enableAutoSave: false,
        readonly: false
      },
      myConfigNoImg: {
        initialFrameHeight: 240,
        UEDITOR_HOME_URL: '/ueditor/',
        // UEDITOR_HOME_URL: window.location.origin +'/'+ window.location.pathname.split('/')[1]+'/ueditor/',
        toolbars: [
          [
            'source',
            'undo', //撤销
            'bold', //加粗
            'indent', //首行缩进
            'italic', //斜体
            'underline', //下划线
            'strikethrough', //删除线
            'subscript', //下标
            'fontborder', //字符边框
            'superscript', //上标
            'formatmatch', //格式刷
            'fontfamily', //字体
            'fontsize', //字号
            'justifyleft', //居左对齐
            'justifycenter', //居中对齐
            'justifyright', //居右对齐
            'justifyjustify', //两端对齐
            'insertorderedlist', //有序列表
            'insertunorderedlist', //无序列表
            'lineheight', //行间距
            'forecolor' //字体颜色
          ]
        ],
        // 初始容器宽度
        initialFrameWidth: '100%',
        zIndex: 9001,
        enableAutoSave: false,
        readonly: false
      },
      OperationPreview: false,
      InstructionsForm: {
        formDesc: '',
        formName: '',
        attachment: '',
        id: '',
        formKey: '',
        descNote: '',
        attachmentManagement: '',
        formInfoDetailRequestVoList: [
          {
            attachment: '',
            formDesc: '',
            infoName: '',
            sn: 0
          }
        ]
      },
      OperationInstructions: false,
      asideShow: true,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      dialogVisible2: false,
      formEditorDialogVisible: false,
      dialogSaveCopyVisible: false,
      formId: null,
      formDefId: null,
      bpmForm: {
        formKey: '',
        bos: '',
        desc: ''
      },
      typeIdQuery: null,
      formVersionVisible: false,
      formPrintVisible: false,
      formKey: null,
      updateTableData: [],
      formRow: {},
      newForm: { id: '', name: '', formKey: '', typeId: '', typeName: '' },
      importDialogVisible: false,
      formTypeSelectorCatId: '',
      formTypeSelectorCatName: '',
      fullscreenLoading: false,
      tenantId: '-1',
      bindData: [],
      waterMarkVisible: false,
      waterMarkSettingOptions: [],
      waterMarkSetting: {
        id: ''
      },
      activeName: 'first',
      tabList: [
        {
          label: '功能介绍',
          name: 'first'
        },
        {
          label: '操作流程',
          name: 'second'
        },
        {
          label: '注意事项',
          name: 'third'
        },
        {
          label: '管理制度',
          name: 'fourth'
        }
      ],
      saveHtml: ''
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.login.currentUser,
      formDeleteUrl: function () {
        return `${window.context.form}/form/form/v1/remove`
      },
      uploadHeaders: function (mapState) {
        return { Authorization: 'Bearer ' + mapState.login.currentUser.token }
      },
      imporCheckUrl: function (mapState) {
        return window.context.form + '/form/form/v1/importCheck?typeId=' + this.formTypeSelectorCatId
      }
    })
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.$validator = this.$root.$validator
  },
  methods: {
    //设置分类
    openTypeSetDialog() {
      if (this.updateTableData.length == 0) {
        this.$message({
          message: '请先选择需要设置分类的数据',
          type: 'warning'
        })
        return
      }
      this.$refs.typeSetDialog.showDialog({})
    },
    sysTypeDialogOnConfirm(data) {
      var id = []
      for (let i = 0; i < this.updateTableData.length; i++) {
        id.push(this.updateTableData[i].id)
      }
      let this_ = this
      this.$http.get('${portal}/sys/sysType/v1/updateEntitySysType?typeID=' + data.id + '&entityIds=' + id.join(',')).then(function (resp) {
        if (resp.data && resp.data.state) {
          this_.$message({ message: resp.data.message, type: 'success' })
          this_.updateTableData = []
          setTimeout(function () {
            this_.dialogVisible = false
            this_.$refs.ecoTable.load()
          }, 3000)

          return
        }
        this_.$message.error(resp.data.message)
      })
    },
    openFormVersion(row) {
      this.formKey = row.formKey
      this.formVersionVisible = true
    },
    handleCloseFormVersion() {
      this.formVersionVisible = false
      this.$refs.ecoTable.load()
    },
    handleCloseFormPrint() {
      this.formPrintVisible = false
    },
    formAuth(formKey) {
      let param = {
        flowKey: '',
        formKey: formKey,
        nodeId: '',
        parentflowKey: '',
        type: '3'
      }
      this.$refs.FormDesignRules.showDialog(param)
    },
    handleNodeClick(node) {
      if (node.typeKey == 'FORM_TYPE') {
        this.typeIdQuery = null
      } else {
        this.bpmForm.typeName = node.name
        this.typeIdQuery = {
          property: 'typeId',
          value: node.id,
          group: 'typeId',
          operation: 'EQUAL',
          relation: 'AND'
        }
      }
      this.$refs.ecoTable.load()
    },
    check(data, checkObj) {
      if (checkObj.checkedKeys.length == 0) {
        this.typeIdQuery = null
      } else {
        this.typeIdQuery = {
          property: 'typeId',
          value: checkObj.checkedKeys.join(','),
          group: 'typeId',
          operation: 'IN',
          relation: 'AND'
        }
      }
      this.$refs.ecoTable.load()
    },
    loadData(param, cb) {
      if (!param.querys) {
        param.querys = [
          {
            group: 'defaultQueryGroup',
            operation: 'EQUAL',
            relation: 'AND',
            property: 'formType',
            value: 'pc'
          }
        ]
      } else {
        param.querys.push({
          group: 'defaultQueryGroup',
          operation: 'EQUAL',
          relation: 'AND',
          property: 'formType',
          value: 'pc'
        })
      }
      if (this.typeIdQuery) {
        param.querys.push(this.typeIdQuery)
      }
      form
        .getPageJson(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      this.formRow = params.row
      switch (params.command) {
        case 'formRight':
          this.formAuth(params.row.formKey)
          break
        case 'formExpand':
          this.formExpand(this.formRow)
          break
        case 'operationInstructions':
          this.handleOperationInstructions(this.formRow)
          break
        case 'waterMark':
          let param = {
            pageBean: { page: 1, pageSize: 99999, total: 0 },
            querys: [
              {
                group: 'defaultQueryGroup',
                operation: 'EQUAL',
                relation: 'AND',
                property: 'status',
                value: '1'
              }
            ],
            sorter: [{ property: 'CREATE_TIME_', direction: 'DESC' }]
          }
          portal.getWaterMarkAll(param).then((resp) => {
            if (resp.rows) {
              this.waterMarkSettingOptions = resp.rows
              portal.getWaterMarkByFormKey(this.formRow.formKey).then((resp) => {
                if (resp) {
                  this.waterMarkSetting.id = resp.id
                }
                this.waterMarkVisible = true
              })
            }
          })
          break
        default:
          break
      }
    },
    bindRelation(params) {
      this.dialogVisible2 = true
      form.getBindRelation(params.row.defId, params.row.formKey).then((resp) => {
        this.bindData = resp.data
      })
    },
    saveCopy() {
      this.newForm.id = this.formRow.id
      this.dialogSaveCopyVisible = true
    },
    handleCloseSaveCopy() {
      this.dialogSaveCopyVisible = false
    },
    afterSaveData() {
      this.handleCloseSaveCopy()
      this.$refs.ecoTable.load()
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisible2 = false
      this.OperationInstructions = false
    },
    handlePreviewClose() {
      this.OperationPreview = false
    },
    handleWaterMarkClose() {
      this.waterMarkVisible = false
    },
    openAddDailog() {
      this.$refs.eipBoDialog.showDialog([])
      // this.dialogVisible = true;
      this.$set(this.bpmForm, 'formKey', '')
      this.$set(this.bpmForm, 'bos', '')
      this.$set(this.bpmForm, 'desc', '')
      this.$set(this.bpmForm, 'formName', '')
      this.$set(this.bpmForm, 'name', '')
      if (this.bpmForm.typeName) {
        this.$set(this.bpmForm, 'typeName', this.bpmForm.typeName)
      } else {
        this.$set(this.bpmForm, 'typeName', '')
      }
      this.$set(this.bpmForm, 'typeId', '')
      this.$set(this.bpmForm, 'id', '')
      this.$set(this.bpmForm, 'defId', '')
      this.$set(this.bpmForm, 'rev', 1)
    },
    handleCloseFormEditor() {
      this.formEditorDialogVisible = false
      this.$refs.ecoTable.load()
    },
    toFormDesigner() {
      utils
        .validateForm(this, 'editBpmForm')
        .then(() => {
          this.bpmForm.formType = 'pc'
          this.bpmForm.name = this.bpmForm.formName
          this.formId = ''
          this.formDefId = ''
          this.formEditorDialogVisible = true
          this.handleClose()
        })
        .catch((reason) => {
          let rules = reason.map((obj) => {
            return obj.rule
          }) //获取到报错后的规则数组
          if (rules.includes('required')) {
            this.$message.error('请完整填写表单内容')
          } else if (rules.includes('alpha_num')) {
            this.$message.error('信息未正确填写')
          } else if (rules.includes('isExist')) {
            this.$message.error('表单别名重复')
          }
        })
    },
    createMobileForm(row) {
      this.$http.post('${form}/form/form/v1/pcForm2MobileForm?formId=' + row.id).then((response) => {
        if (response.data.state) {
          this.$message({
            type: 'success',
            message: response.data.message
          })
          this.$refs.ecoTable.load()
        } else {
          this.$message.$error(response.data.message)
        }
      })
    },
    handleOperationInstructions(row) {
      if (row) {
        this.InstructionsForm = {
          formDesc: '',
          formName: row.name,
          attachment: '',
          id: '',
          formKey: row.formKey,
          descNote: '',
          attachmentManagement: '',
          formInfoDetailRequestVoList: []
        }
      }
      this.defaultOperationInstructions(row, false)
      this.activeName = 'first'
      this.OperationInstructions = true
    },
    defaultOperationInstructions(row, isDefault = true) {
      let p = '${form}/form/info/v1/getDefaultInfoFormKey?formKey='
      if (this.tenantId != '-1') {
        p = '${form}/form/info/v1/getInfoByFormKey?formKey='
      }
      if (isDefault) {
        p = '${form}/form/info/v1/getDefaultInfoFormKey?formKey='
      }
      this.$http.get(p + row.formKey).then((res) => {
        if (res && res.data) {
          if (isDefault) {
            this.InstructionsForm.formDesc = res.data.formDesc
            // this.InstructionsForm.formName = res.data.formName;
            this.InstructionsForm.attachment = res.data.attachment
            this.InstructionsForm.formKey = res.data.formKey
            this.InstructionsForm.descNote = res.data.descNote
            this.InstructionsForm.attachmentManagement = res.data.attachmentManagement
            this.InstructionsForm.formInfoDetailRequestVoList = res.data.formInfoDetailRequestVoList
          } else {
            this.InstructionsForm = res.data
            this.InstructionsForm.formName = row.name
          }
        }
      })
    },
    saveOperationInstructions() {
      let saveForm = false
      if (this.InstructionsForm.formDesc.length === 0) {
        return this.$message.info('功能介绍操作说明必填')
      }
      if (this.InstructionsForm.formInfoDetailRequestVoList && this.InstructionsForm.formInfoDetailRequestVoList.length) {
        saveForm = this.InstructionsForm.formInfoDetailRequestVoList.every(
          (item) => item.attachment !== '' && item.formDesc !== '' && item.infoName !== '' && item.sn !== ''
        )
      } else {
        saveForm = true
      }
      if (saveForm) {
        this.$http.post('${form}/form/info/v1/saveInfo', this.InstructionsForm).then((res) => {
          if (res && res.data && res.data.state) {
            this.$message.success(res.data.message)
            this.initOperationInstructions()
          }
        })
      } else {
        return this.$message.info('操作步骤中有必填项未填写')
      }
    },
    initOperationInstructions() {
      this.InstructionsForm = {
        formDesc: '',
        formName: '',
        attachment: '',
        id: '',
        formKey: '',
        descNote: '',
        attachmentManagement: '',
        formInfoDetailRequestVoList: []
      }
      this.OperationInstructions = false
    },
    PreviewDialog() {
      this.$store.dispatch('login/saveHtmlSrc', this.InstructionsForm.formKey).then((htmlSrc) => {
        if (htmlSrc) {
          this.saveHtml = htmlSrc
          this.OperationPreview = true
        }
      })
    },
    formExpand(formRow) {
      let param = {
        formId: formRow.id,
        formKey: formRow.formKey,
        formName: formRow.name,
        version: formRow.version
      }
      this.$refs.FormExpandManage.showDialog(param)
    },
    saveWaterMark() {
      if (!this.waterMarkSetting.id) {
        this.$message.warning('请选择水印')
        return
      }
      let watermarkForms = [
        {
          watermark_id: this.waterMarkSetting.id,
          form_key: this.formRow.formKey,
          form_id: this.formRow.id,
          form_name: this.formRow.name
        }
      ]
      let param = {
        id: this.waterMarkSetting.id,
        watermark_forms: watermarkForms
      }
      portal.saveWaterMarkForm(param, 'true').then((response) => {
        if (response.state) {
          this.waterMarkVisible = false
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
      })
    },
    handleClick() {
      if (this.activeName === 'second' && this.InstructionsForm.formInfoDetailRequestVoList && !this.InstructionsForm.formInfoDetailRequestVoList.length) {
        // this.InstructionsForm.formInfoDetailRequestVoList.push({
        //   attachment: "",
        //   formDesc: "",
        //   infoName: "",
        //   sn: 0
        // });
      }
    },
    addStep(index) {
      this.InstructionsForm.formInfoDetailRequestVoList.push({
        attachment: '',
        formDesc: '',
        infoName: '',
        sn: index
      })
    },
    deleteStep(index) {
      this.InstructionsForm.formInfoDetailRequestVoList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-editor-dialog >>> .el-dialog__header {
  display: none;
}

.form-version__dialog /deep/ > .el-dialog > .el-dialog__body {
  padding: 0 10px;
}

.form-editor-dialog >>> .el-dialog__body {
  padding: 0;
  height: 100%;
}
div >>> .el-form-item__error {
  display: none;
}
/deep/ .el-dialog__footer {
  text-align: center;
}
/deep/ .el-dialog__body {
  padding-top: 10;
}
.preview {
  padding: 5px 20px;
  margin-bottom: 15px;
  p {
    margin: 0;
  }
}

.operate_step {
  width: 100%;
  .operate_step_item {
    width: 100%;

    .operate_step_content {
      height: 100%;
      .step_content {
        padding-top: 10px;
        box-sizing: border-box;
        height: 60px;
        display: flex;
        flex-direction: column;
      }
      .step_btn {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
</style>
